module.exports = __webpack_public_path__ + "static/media/face2.bfa37c8e.jpg";